// Single source of truth for the set of language codes the site
// supports. Isolated into its own file so both `index.js` (which
// registers the i18next resources) and `geoDetector.js` (which
// validates the /api/geo response) can import it without creating
// a circular dependency.
export const SUPPORTED_CODES = new Set(["en", "vi", "zh", "ko", "fr", "de", "ru"]);
